import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth.ts';

interface ProtectedRouteProps {
  children: ReactNode;
  /**
   * Restricts the route to users whose Cognito groups intersect this list
   * (e.g. `['Admins']`). Omit for "authenticated or not" gating only.
   */
  allowedGroups?: string[];
}

export function ProtectedRoute({ children, allowedGroups }: ProtectedRouteProps) {
  const { isLoading, isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-phoenix-blue-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedGroups && !allowedGroups.some((g) => user?.groups.includes(g))) {
    return <Navigate to="/portal" replace />;
  }

  return <>{children}</>;
}
